import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';

export class CustomLightButton extends Component {
    render() {
        const { icon, label, onPress, style, disabled } = this.props;

        return (
            <Box
                onClick={() => {
                    if (!disabled) {
                        onPress?.();
                    }
                }}
                sx={{
                    minHeight: 44,
                    borderRadius: '6px',
                    border: '1px solid #5f5f5f',
                    backgroundColor: disabled ? '#2b2b2b' : '#111',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    px: 2,
                    cursor: disabled ? 'default' : 'pointer',
                    userSelect: 'none',
                    opacity: disabled ? 0.7 : 1,
                    ...style,
                }}
            >
                {icon != null && (
                    <Box
                        component="img"
                        src={icon}
                        alt=""
                        sx={{
                            width: 18,
                            height: 18,
                            objectFit: 'contain',
                        }}
                    />
                )}

                <Typography
                    sx={{
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: 14,
                    }}
                >
                    {label}
                </Typography>
            </Box>
        );
    }
}

export default CustomLightButton;